export const SET_SHOW_REJECT_ACCEPT_BUTTON = "SET_SHOW_REJECT_ACCEPT_BUTTON";
export const SET_LISTING_DETAIL = "SET_LISTING_DETAIL";

export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";

export const SET_USER_PROFILE = "SET_USER_PROFILE";

export const SET_LIST_PROVINCES = "SET_LIST_PROVINCES";
export const SET_LIST_DISTRICTS = "SET_LIST_DISTRICTS";

export const LIST_PACKAGES = "LIST_PACKAGES";

export const LIST_CATEGORY_CHILD = "LIST_CATEGORY_CHILD";

export const SET_LIST_CATEGORY_CHILD = "SET_LIST_CATEGORY_CHILD";

export const LIST_SELLER_LISTING = "LIST_SELLER_LISTING";

export const REPORT_TYPE = "REPORT_TYPE";

export const LISTING_DETAILS_FOR_FRONT = "LISTING_DETAILS_FOR_FRONT";

export const LIST_COIN_PACKAGES = "LIST_COIN_PACKAGES";

export const LIST_BANNER = "LIST_BANNER";

export const LISTING_PREVIEW = "LISTING_PREVIEW";

export const LIST_CATEGORY = "LIST_CATEGORY";

export const LISTING_JUST_CREATED = "LISTING_JUST_CREATED";


export const SET_LISTING_INTERESTINGS = "SET_LISTING_INTERESTINGS";

export const SET_LISTING_SELLER_DETAIL = "SET_LISTING_SELLER_DETAIL";

export const SET_LISTING_FAVOURITES_USER = "SET_LISTING_FAVOURITES_USER";

export const UPDATE_LISTING_FAVOURITES_USER = "UPDATE_LISTING_FAVOURITES_USER";

export const SET_USER_LISTING = "SET_USER_LISTING";
export const IS_DELETE_LISTING = "IS_DELETE_LISTING";
export const IS_SOLD_LISTING = "IS_SOLD_LISTING";

export const SET_LISTING_USER_MESSAGE = "SET_LISTING_USER_MESSAGE";

export const SET_LISTING_USER_MESSAGE_DETAIL = "SET_LISTING_USER_MESSAGE_DETAIL";

export const UPDATE_LISTING_USER_MESSAGE = "UPDATE_LISTING_USER_MESSAGE";

// Admin 
export const SET_LISTINGS_WAITING_FOR_APPROVE = "SET_LISTINGS_WAITING_FOR_APPROVE";
export const SET_ADMIN_RENEW_LISTING_STATUS = "SET_ADMIN_RENEW_LISTING_STATUS";
export const SET_ADMIN_REJECT_LISTING_STATUS = "SET_ADMIN_REJECT_LISTING_STATUS";
export const SET_ADMIN_DELETE_LISTING_STATUS = "SET_ADMIN_DELETE_LISTING_STATUS";
export const SET_ADMIN_GET_LISTING_DETAIL = "SET_ADMIN_GET_LISTING_DETAIL";

export const SET_DATA_SEARCH_CATEGORY = "SET_DATA_SEARCH_CATEGORY"

export const SET_DATA_PROVINCES = "SET_DATA_PROVINCES";

export const SET_DATA_AMPHURES = "SET_DATA_AMPHURES";

export const SET_DATA_DISTRISTS = "SET_DATA_DISTRISTS";

export const SET_LISTING_ATTR = "SET_LISTING_ATTR";

export const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";

export const SET_ID_ATTR = "SET_ID_ATTR";

export const SET_DATA_USER_DASHBOARD = "SET_DATA_USER_DASHBOARD";

export const SET_DATA_USER_DASHBOARD_MESSAGE = "SET_DATA_USER_DASHBOARD_MESSAGE";

// user contact topic

export const SET_DATA_USER_CONTACT_TOPIC = "SET_DATA_USER_CONTACT_TOPIC";

export const SET_DATA_USER_CONTACT_ADVERTISEMENT = "SET_DATA_USER_CONTACT_ADVERTISEMENT";

export const SET_DATA_USER_CONTACT_PERIOD = "SET_DATA_USER_CONTACT_PERIOD";

export const POST_DATA_CONTACT_SUCCESS = "POST_DATA_CONTACT_SUCCESS";

export const VALUE_WHEN_REDIRECT_ADD_LISTING = "VALUE_WHEN_REDIRECT_ADD_LISTING";

export const UPDATE_UNREAD_MESSAGE_USER_DASHBOARD = "UPDATE_UNREAD_MESSAGE_USER_DASHBOARD";

export const SET_ADMIN_MESSAGE_LISTING = "SET_ADMIN_MESSAGE_LISTING";

export const SET_ADMIN_MESSAGE_LISTING_DETAIL = "SET_ADMIN_MESSAGE_LISTING_DETAIL";

export const UPDATE_LISTING_ADMIN_MESSAGE = "UPDATE_LISTING_ADMIN_MESSAGE";

export const UPDATE_ITEM_CHECKED_ADMIN_REPORT = "UPDATE_ITEM_CHECKED_ADMIN_REPORT";

export const UPDATE_ITEM_ADMIN_MESSAGE = "UPDATE_ITEM_ADMIN_MESSAGE";

export const SET_EMAIL_TEMPLATE = "SET_EMAIL_TEMPLATE";

export const RESET_USER_LISTING = "RESET_USER_LISTING";

export const SET_DATA_SEARCH_ADMIN = "SET_DATA_SEARCH_ADMIN";

export const SET_DATA_USER_MANAGER = "SET_DATA_USER_MANAGER";

export const SET_ADMIN_BANNER_TYPES = "SET_ADMIN_BANNER_TYPES";

export const SET_DATA_ADMIN_DASHBOARD = "SET_DATA_ADMIN_DASHBOARD";

export const SET_LISTINGS_WAITING_DATA = "SET_LISTINGS_WAITING_DATA";

export const ADMIN_SET_ANALYTICS = "ADMIN_SET_ANALYTICS";

export const SET_USER_LISTING_PACKAGE = "SET_USER_LISTING_PACKAGE";

export const SET_SITE_TIPS = "SET_SITE_TIPS";
export const SET_PROJECT_CONFIG = "SET_PROJECT_CONFIG";
export const SET_SITE_CONFIG = "SET_SITE_CONFIG";

export const UPDATE_SITE_CONFIG = "UPDATE_SITE_CONFIG";

export const USER_SET_ANALYTICS = "USER_SET_ANALYTICS";

export const SET_BROWSER_ID = "SET_BROWSER_ID";

//chat

export const SET_UNREAD_MESSAGE="SET_UNREAD_MESSAGE";

//agency

export const SET_AGENCY_DATA="SET_AGENCY_DATA";